import { PACKAGES } from './payment';

const ADVERT_CLICK = 'clickAddAdButton_';
// const SERVICE = 'service';
const TARIFF_PLAN = 'tariffplan';
const SERVICE = 'service';
const TARIFF_PLAN_BUSINESS = 'tariffplan_business';
const SERVICE_BUSINESS = 'service_business';
const { C2C_SLOT, C2C_SINGLE, C2C_TURBO, C2C_FAST } = PACKAGES;

export const EVENTS = {
  MOBILE: {
    sendMessageToOwner: { event: 'sendlOwnerMessage_button' },
    registrationSuccess: { event: 'successRegistration' },
    adSent0: { event: 'clickAddAdButton_Free' },
    adSent1: { event: 'clickAddAdButton_109' },
    adSent2: { event: 'clickAddAdButton_199' },
    adSent3: { event: 'clickAddAdButton_299' },
    // Page types
    pageMain: { pageType: 'mainpage' },
    pageAdCard: { pageType: 'Ad_card' },
    pageDealer: { pageType: 'Dealer_Page' },
    pageSearch: { pageType: 'catalog' },
    pageAddAdvMainInfo: { pageType: 'Step 1' },
    pageAddAdvContactsPhoto: { pageType: 'Step 2' },
    pageAddAdvSellCar: { pageType: 'Step 3' },

    //
    pageDealers: { pageType: 'Dealers_Page' },
    pageProfile: { pageType: 'Profile_Page' },
    pageGeo: { pageType: 'Geo_Page' },
    pageFilters: { pageType: 'Filters_Page' },
    pageFavorites: { pageType: 'Favorites_Page' },
  },
  // Adverts
  AddCarNumberButton: { event: 'Add__NumberButton' },
  AddChooseBrand: { event: 'Add__ChooseBrand' },
  AddPhotoAdded: { event: 'Add__PhotoAdded' },
  AddPhotoDeleted: { event: 'Add__PhotoDeleted' },
  AddPhotoSort: { event: 'Add__PhotoSort' },
  AddSubmit: { event: 'Add__Submit' },
  AddSubmitFinal: { event: 'Add__SubmitFinall' },
  AddClearWarningMessageAndSubmit: { event: 'Add__SubmitAfterError' },
  AddSubmitForm: { event: 'Add__SubmitForm' },
  AddNextButtonCommon: { event: 'Add__NextButtonAll' },
  AddCommonPublishButton: { event: 'Add__PublishButtonAll' },
  // AddNextButton1: { event: 'Add__NextButton-1' },
  // AddNextButton2: { event: 'Add__NextButton-2' },
  // AddNextButton3: { event: 'Add__NextButton-3' },
  // AddNextButton4: { event: 'Add__NextButton-4' },

  AddCarBrandGroup: { event: 'AddCarBrandGroup' },
  freeAdSent: { event: 'freeAdSent' },
  turboAdvert: { event: `${ADVERT_CLICK}333_Turbo` },
  fastAdvert: { event: `${ADVERT_CLICK}198_Quick` },
  freeAll: { event: `${ADVERT_CLICK}555_All` },
  freeUp: { event: `${ADVERT_CLICK}105_Autopromotion` },
  freeVip: { event: `${ADVERT_CLICK}225_VIP` },
  freeCol: { event: `${ADVERT_CLICK}75_Colour` },
  freeTop: { event: `${ADVERT_CLICK}150_TOP` },
  freeUpVipCol: { event: `${ADVERT_CLICK}405_Auto+VIP+Colour` },
  freeUpVip: { event: `${ADVERT_CLICK}330_Auto+VIP` },
  freeUpCol: { event: `${ADVERT_CLICK}180_Auto+Colour` },
  freeUpTop: { event: `${ADVERT_CLICK}150_Auto+Top` },
  freeUpTopCol: { event: `${ADVERT_CLICK}225_Auto+Top+Colour` },
  freeVipVolTop: { event: `${ADVERT_CLICK}450_VIP+Colour+Top` },
  freeVipCol: { event: `${ADVERT_CLICK}300_Vip+Colour` },
  freeVipTop: { event: `${ADVERT_CLICK}375_Vip+Top` },
  freeVipTopUp: { event: `${ADVERT_CLICK}480_Vip+Top+Auto` },
  freeColTop: { event: `${ADVERT_CLICK}225_Colour+Top` },
  //
  addToFavorites: { event: 'likeCar_button' },
  sellCarButtonClick: { event: 'sellCarr_Button' },
  seeReviews: { event: 'see_review_Button' },
  showPhoneClick: { event: 'showPhone_button' },
  sendTestDriveForm: { event: 'sendTestDrive_Form' },
  dealerSiteRedirect: { event: 'goDealerSite_Button' },
  showAllDealerAdverts: { event: 'showAllDealerCars_Button' },
  successLogin: { event: 'successRegistration' },
  callOwner: { event: 'callOwner_button' },
  searchButtonClick: { event: 'pressSearchButton' },
  paidAdSent: { event: 'paidAdSent' },
  advert: {
    'balance-refill': { event: `balance_refil` },
    [C2C_SLOT]: { event: `${TARIFF_PLAN}/4/` },
    'sp-slot': { event: `${TARIFF_PLAN}/25/` },
    [C2C_SINGLE]: { event: `${TARIFF_PLAN}/31/` },
    update: { event: `${SERVICE}/1/` },
    vip: { event: `${SERVICE}/2/` },
    top: { event: `${SERVICE}/4/` },
    color: { event: `${SERVICE}/3/` },
    [C2C_TURBO]: { event: `${TARIFF_PLAN}/6/` },
    [C2C_FAST]: { event: `${TARIFF_PLAN}/5/` },
    b2c: { event: `${TARIFF_PLAN_BUSINESS}/2/` },
    business: {
      [C2C_SINGLE]: { event: `${TARIFF_PLAN_BUSINESS}/31/` },
      b2c: { event: `${TARIFF_PLAN_BUSINESS}/2/` },
      update: { event: `${SERVICE_BUSINESS}/1/` },
      vip: { event: `${SERVICE_BUSINESS}/2/` },
      top: { event: `${SERVICE_BUSINESS}/4/` },
      color: { event: `${SERVICE_BUSINESS}/3/` },
      [C2C_FAST]: { event: `${TARIFF_PLAN_BUSINESS}/5/` },
      [C2C_TURBO]: { event: `${TARIFF_PLAN_BUSINESS}/6/` },
      'spareparts-500': { event: `${TARIFF_PLAN_BUSINESS}/7/` },
      'spareparts-1000': { event: `${TARIFF_PLAN_BUSINESS}/8/` },
      'spareparts-2000': { event: `${TARIFF_PLAN_BUSINESS}/9/` },
      'spareparts-3000': { event: `${TARIFF_PLAN_BUSINESS}/10/` },
      'spareparts-unlim': { event: `${TARIFF_PLAN_BUSINESS}/11/` },
      'spareparts-batch-update-20': { event: `${TARIFF_PLAN_BUSINESS}/18/` },
      'spareparts-batch-update-35': { event: `${TARIFF_PLAN_BUSINESS}/19/` },
      'spareparts-batch-update-70': { event: `${TARIFF_PLAN_BUSINESS}/20/` },
      'spareparts-batch-update-100': { event: `${TARIFF_PLAN_BUSINESS}/21/` },
      'spareparts-batch-update-150': { event: `${TARIFF_PLAN_BUSINESS}/22/` },
      'spareparts-batch-update-200': { event: `${TARIFF_PLAN_BUSINESS}/23/` },
      'spareparts-batch-update-400': { event: `${TARIFF_PLAN_BUSINESS}/24/` },
    },
    dealership: {
      'spareparts-500': { event: `${TARIFF_PLAN}/7/` },
      'spareparts-1000': { event: `${TARIFF_PLAN}/8/` },
      'spareparts-2000': { event: `${TARIFF_PLAN}/9/` },
      'spareparts-3000': { event: `${TARIFF_PLAN}/10/` },
      'spareparts-unlim': { event: `${TARIFF_PLAN}/11/` },
      'spareparts-batch-update-20': { event: `${TARIFF_PLAN}/18/` },
      'spareparts-batch-update-35': { event: `${TARIFF_PLAN}/19/` },
      'spareparts-batch-update-70': { event: `${TARIFF_PLAN}/20/` },
      'spareparts-batch-update-100': { event: `${TARIFF_PLAN}/21/` },
      'spareparts-batch-update-150': { event: `${TARIFF_PLAN}/22/` },
      'spareparts-batch-update-200': { event: `${TARIFF_PLAN}/23/` },
      'spareparts-batch-update-400': { event: `${TARIFF_PLAN}/24/` },
    },
  },
  leasing: {
    'data-lens-event': { event: `leasingRequestClick` },
    'page-view': { event: `leasingPageView` },

    // Automoney
    'automoney-monthly-calculation-show-form-click': {
      event: `automoney-LeasingMonthly-Calculation-Show-Form-Click`,
    },
    'automoney-monthly-calculation-form-sumbit': {
      event: `automoney-LeasingMonthly-Calculation-Form-Sumbit`,
    },
    'automoney-monthly-consultation-form-sumbit': {
      event: `automoney-LeasingMonthly-Consultation-Form-Submit`,
    },
    'automoney-questions-form-sumbit': { event: `automoney-leasingMonthly-questions-Form-Submit` },
    'automoney-lead-create-success': { event: `automoney-lead-created-success` },
    'automoney-lead-create-fail': { event: `automoney-lead-create-fail` },
    'automoney-monthly-calculation-show-form-click-advertcard': {
      event: `automoney-leasingMonthly-Calculation-Show-Form-Click-advertCard`,
    },
    'automoney-monthly-calculation-form-sumbit-advertcard': {
      event: `automoney-leasingMonthly-Calculation-Form-Sumbit-advertCard`,
    },
    'automoney-monthly-consultation-form-sumbit-advertcard': {
      event: `automoney-leasingMonthly-Consultation-Form-Submit-advertCard`,
    },
    'automoney-lead-create-success-advertcard': {
      event: `automoney-myauto-lead-create-success-advertCard`,
    },
    'automoney-lead-create-fail-advertcard': {
      event: `automoney-myauto-lead-create-fail-advertCard`,
    },

    // Microcredit
    'microcredit-consultation-show-form-click': {
      event: `microcredit-Consultation-Show-Form-Click`,
    },
    'microcredit-consultation-form-sumbit': { event: `microcredit-Consultation-Form-Submit` },
    'microcredit-lead-create-success': { event: `microcredit-lead-created-success` },
    'microcredit-lead-create-fail': { event: `microcredit-lead-create-fail` },

    'microcredit-consultation-show-form-click-advertcard': {
      event: `microcredit-Consultation-Show-Form-Click-advertCard`,
    },
    'microcredit-consultation-form-sumbit-advertcard': {
      event: `microcredit-Consultation-Form-Submit-advertCard`,
    },
    'microcredit-lead-create-success-advertcard': {
      event: `microcredit-lead-created-success-advertCard`,
    },
    'microcredit-lead-create-fail-advertcard': { event: `microcredit-lead-create-fail-advertCard` },

    // Creditmarket
    'creditmarket-consultation-show-form-click': {
      event: `creditmarket-Consultation-Show-Form-Click`,
    },
    'creditmarket-consultation-form-sumbit': { event: `creditmarket-Consultation-Form-Submit` },
    'creditmarket-lead-create-success': { event: `creditmarket-lead-created-success` },
    'creditmarket-lead-create-fail': { event: `creditmarket-lead-create-fail` },

    'creditmarket-consultation-show-form-click-advertcard': {
      event: `creditmarket-Consultation-Show-Form-Click-advertCard`,
    },
    'creditmarket-consultation-form-sumbit-advertcard': {
      event: `creditmarket-Consultation-Form-Submit-advertCard`,
    },
    'creditmarket-lead-create-success-advertcard': {
      event: `creditmarket-lead-created-success-advertCard`,
    },
    'creditmarket-lead-create-fail-advertcard': {
      event: `creditmarket-lead-create-fail-advertCard`,
    },
    'creditmarket-questions-form-sumbit': {
      event: `creditmarket-leasingMonthly-questions-Form-Submit`,
    },

    // MyAuto
    'monthly-calculation-show-form-click': { event: `leasingMonthly-Calculation-Show-Form-Click` },
    'monthly-calculation-form-sumbit': { event: `leasingMonthly-Calculation-Form-Sumbit` },
    'monthly-consultation-form-sumbit': { event: `leasingMonthly-Consultation-Form-Submit` },
    'questions-form-sumbit': { event: `leasingMonthly-questions-Form-Submit` },
    'lead-create-success-questions': { event: `lead-create-success-questions` },
    'lead-create-fail-questions': { event: `lead-create-fail-questions` },
    'lead-create-success': { event: `lead-create-success` },
    'lead-create-fail': { event: `lead-create-fail` },
    'monthly-calculation-show-form-click-advertcard': {
      event: `leasingMonthly-Calculation-Show-Form-Click-advertCard`,
    },
    'monthly-calculation-form-sumbit-advertcard': {
      event: `leasingMonthly-Calculation-Form-Sumbit-advertCard`,
    },
    'monthly-consultation-form-sumbit-advertcard': {
      event: `leasingMonthly-Consultation-Form-Submit-advertCard`,
    },
    // 'questions-form-sumbit-advertcard': { event: `leasingMonthly-questions-Form-Submit-advertCard` },
    'lead-create-success-advertcard': { event: `lead-create-success-advertCard` },
    'lead-create-fail-advertcard': { event: `lead-create-fail-advertCard` },
    'lead-create-success-advertcard-sidebar': { event: `lead-create-success-advertCard-sidebar` },
    'lead-create-fail-advertcard-sidebar': { event: `lead-create-fail-advertCard-sidebar` },

    // Hapai
    'hapai-monthly-calculation-show-form-click': {
      event: `hapai-LeasingMonthly-Calculation-Show-Form-Click`,
    },
    'hapai-monthly-calculation-form-sumbit': {
      event: `hapai-LeasingMonthly-Calculation-Form-Sumbit`,
    },
    'hapai-monthly-consultation-form-sumbit': {
      event: `hapai-LeasingMonthly-Consultation-Form-Submit`,
    },
    'hapai-questions-form-sumbit': { event: `hapai-leasingMonthly-questions-Form-Submit` },
    'hapai-lead-create-success': { event: `hapai-lead-created-success` },
    'hapai-lead-create-success-questions': { event: `hapai-lead-create-success-questions` },
    'hapai-lead-create-fail-questions': { event: `hapai-lead-create-fail-questions` },
    'hapai-lead-create-fail': { event: `hapai-lead-create-fail` },
    'hapai-monthly-calculation-show-form-click-advertcard': {
      event: `hapai-leasingMonthly-Calculation-Show-Form-Click-advertCard`,
    },
    'hapai-monthly-calculation-form-sumbit-advertcard': {
      event: `hapai-leasingMonthly-Calculation-Form-Sumbit-advertCard`,
    },
    'hapai-monthly-consultation-form-sumbit-advertcard': {
      event: `hapai-leasingMonthly-Consultation-Form-Submit-advertCard`,
    },
    // 'hapai-questions-form-sumbit-advertcard': { event: `hapai-leasingMonthly-questions-Form-Submit-advertCard` },
    'hapai-lead-create-success-advertcard': { event: `hapai-lead-create-success-advertCard` },
    'hapai-lead-create-fail-advertcard': { event: `hapai-lead-create-fail-advertCard` },
    'hapai-lead-create-success-advertcard-sidebar': {
      event: `hapai-lead-create-success-advertCard-sidebar`,
    },
    'hapai-lead-create-fail-advertcard-sidebar': {
      event: `hapai-lead-create-fail-advertCard-sidebar`,
    },

    // Ulf24
    'ulf24-monthly-calculation-show-form-click': {
      event: `ulf24-LeasingMonthly-Calculation-Show-Form-Click`,
    },
    'ulf24-monthly-calculation-form-sumbit': {
      event: `ulf24-LeasingMonthly-Calculation-Form-Sumbit`,
    },
    'ulf24-monthly-consultation-form-sumbit': {
      event: `ulf24-LeasingMonthly-Consultation-Form-Submit`,
    },
    'ulf24-questions-form-sumbit': { event: `ulf24-leasingMonthly-questions-Form-Submit` },
    'ulf24-lead-create-success': { event: `ulf24-lead-created-success` },
    'ulf24-lead-create-fail': { event: `ulf24-lead-create-fail` },
    'ulf24-monthly-calculation-show-form-click-advertcard': {
      event: `ulf24-leasingMonthly-Calculation-Show-Form-Click-advertCard`,
    },
    'ulf24-monthly-calculation-form-sumbit-advertcard': {
      event: `ulf24-leasingMonthly-Calculation-Form-Sumbit-advertCard`,
    },
    'ulf24-monthly-consultation-form-sumbit-advertcard': {
      event: `ulf24-leasingMonthly-Consultation-Form-Submit-advertCard`,
    },
    // 'ulf24-questions-form-sumbit-advertcard': { event: `ulf24-leasingMonthly-questions-Form-Submit-advertCard` },
    'ulf24-lead-create-success-advertcard': {
      event: `ulf24-myauto-lead-create-success-advertCard`,
    },
    'ulf24-lead-create-fail-advertcard': { event: `ulf24-myauto-lead-create-fail-advertCard` },

    'ulf24-monthly-consultation-form-sumbit-advertcard-sidebar': {
      event: `ulf24-leasingMonthly-Consultation-Form-Submit-advertCard-sidebar`,
    },
    'ulf24-lead-create-success-advertcard-sidebar': {
      event: `ulf24-lead-create-success-advertCard-sidebar`,
    },
    'ulf24-lead-create-fail-advertcard-sidebar': {
      event: `ulf24-lead-create-fail-advertCard-sidebar`,
    },

    // Other events
    online: {
      'Popup-Used-Click': { event: `leasingOnline-Popup-Used-Click` },
      'Popup-New-Click': { event: `leasingOnline-Popup-New-Click` },
      'Sidebar-Used-Click': { event: `leasingOnline-Sidebar-Used-Click` },
      'Sidebar-New-Click': { event: `leasingOnline-Sidebar-New-Click` },
      LinkUnderThePrice: { event: `leasingOnline_LinkUnderThePrice` },
    },
    consultation: {
      'Popup-Used-Click': { event: `leasingConsultation-Popup-Used-Click` },
      'Popup-New-Click': { event: `leasingConsultation-Popup-New-Click` },
      'Sidebar-Used-Click': { event: `leasingConsultation-Sidebar-Used-Click` },
      'Sidebar-New-Click': { event: `leasingConsultation-Sidebar-New-Click` },
      'Hapai-Popup-Used-Click': { event: `hapai-leasingConsultation-Popup-Used-Click` },
      'Hapai-Popup-New-Click': { event: `hapai-leasingConsultation-Popup-New-Click` },
      'Hapai-Sidebar-Used-Click': { event: `hapai-leasingConsultation-Sidebar-Used-Click` },
      'Hapai-Sidebar-New-Click': { event: `hapai-leasingConsultation-Sidebar-New-Click` },
      'Ulf24-Popup-Used-Click': { event: `ulf24-leasingConsultation-Popup-Used-Click` },
      'Ulf24-Popup-New-Click': { event: `ulf24-leasingConsultation-Popup-New-Click` },
      'Ulf24-Sidebar-Used-Click': { event: `ulf24-leasingConsultation-Sidebar-Used-Click` },
      'Ulf24-Sidebar-New-Click': { event: `ulf24-leasingConsultation-Sidebar-New-Click` },
    },

    codeVerification: {
      'Popup-Used-Click': { event: `leasingOnlineCodeVerification-Popup-Used-Click` },
      'Popup-New-Click': { event: `leasingOnlineCodeVerification-Popup-New-Click` },
      'Sidebar-Used-Click': { event: `leasingOnlineCodeVerification-Sidebar-Used-Click` },
      'Sidebar-New-Click': { event: `leasingOnlineCodeVerification-Sidebar-New-Click` },
    },
  },

  NAVIGATION_LINK: {
    'headerNavigation/avto/avtosalony/': { event: 'avtosalony_nav_legkovye' },
    'headerNavigation/avtosalony/': { event: 'avtosalony_nav_avtosalony' },
    'headerNavigation/avtosalony/avtosalony/avto/': { event: 'avtosalony_nav_avtosalony_avto' },
    'subHeader/avtosalony/': { event: 'avtosalony_sub-nav_avtosalony' },
  },

  DEALERS: {
    showNubmer: { event: 'avtosalony_listing_show-nubmer' },
    testDrive: { event: 'avtosalony_listing_test-drive' },
    tradeIn: { event: 'avtosalony_listing_trade-in' },

    formTestDrive: { event: 'avtosalony_listing_form_test-drive' },
    formTradeIn: { event: 'avtosalony_listing_form_trade-in' },
  },

  DEALER_ADV: {
    showNubmer: { event: 'avtosalony_car_show-number' },
    tradeIn: { event: 'avtosalony_car_trade-in' },
    testDrive: { event: 'avtosalony_car_testDrive' },
    callback: { event: 'avtosalony_car_callback' },

    formTradeIn: { event: 'avtosalony_car_form_trade-in' },
    formTestDrive: { event: 'avtosalony_car_form_testDrive' },
    formCallback: { event: 'avtosalony_car_form_callback' },
  },

  DEALER_CARD: {
    showNubmer: { event: 'avtosalony_card_show-number' },
    goToSite: { event: 'avtosalony_card_site' },

    tradeIn: { event: 'avtosalony_card_trade-in' },
    testDrive: { event: 'avtosalony_card_test-drive' },

    formTradeIn: { event: 'avtosalony_card_form_trade-in' },
    formTestDrive: { event: 'avtosalony_card_form_test-drive' },
  },
};



// WEBPACK FOOTER //
// ./src/shared/constants/gtmEvents.js